// Canonical file-type and size limits for client/document uploads, shared by the staff app
// (SONeuWebApp drop zone) and the external upload page (SONeuExternalApp) so both pre-validate
// identically. The backend (DropZoneFileTypeValidator + FileStorageOptions) is the source of
// truth and re-validates every upload — these values only drive the client-side UX.

export const MAX_UPLOAD_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB

// MIME type -> accepted extensions. Shape matches react-dropzone's `accept` prop.
export const ACCEPTED_UPLOAD_FILE_TYPES: Record<string, string[]> = {
  "application/pdf": [".pdf"],
  "application/vnd.ms-outlook": [".msg"],
  "message/rfc822": [".eml"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "text/plain": [".txt"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
};

// Unique, lower-case extensions (with leading dot) for client-side validation.
export const ACCEPTED_UPLOAD_EXTENSIONS: string[] = [...new Set(Object.values(ACCEPTED_UPLOAD_FILE_TYPES).flat())];

// Human-readable list, e.g. "PDF, MSG, EML, JPG, JPEG, PNG, TXT, DOCX, XLSX".
export const ACCEPTED_UPLOAD_EXTENSIONS_LABEL: string = ACCEPTED_UPLOAD_EXTENSIONS.map((ext) =>
  ext.replace(".", "").toUpperCase()
).join(", ");
